<template>
  <div class="content">
    <h2>{{ father }} | Reportes Grilla</h2>
    <v-dialog v-model="dialog" content-class="reporte">
      <v-card>
        <v-card-title class="grey lighten-4">
          Reporte Notas
          <v-row justify="end" no-gutters>
            <v-col md="auto" class="pt-0 pb-0">
              <!--<v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" class="iconoDescargar" @click="descargarPDF">save_alt</v-icon>
                </template>
                <span>Descargar Planilla</span>
              </v-tooltip>-->
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="blue-grey"
                    class="ma-2 white--text"
                    fab
                    v-on="on"
                    @click="descargarPDF"
                  >
                    <v-icon dark>mdi-cloud-download</v-icon>
                  </v-btn>
                </template>
                <span>Descargar Planilla</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-title>
        <template v-if="alumnos.length > 0">
          <!--
          <v-row class="colorHeaders align-center">
            <v-col cols="2" class="text-center">Alumno</v-col>
            <template v-for="(materia, index_mat) in materias">
              <v-col cols="1" align-center :key="index_mat">{{mayusculas(materia.nombre)}}</v-col>
            </template>
          </v-row>-->
          <v-layout class="colorHeaders align-center" align="center">
            <v-flex xs3 class="text-center">Alumno</v-flex>
            <template v-for="(materia, index_mat) in materias">
              <v-flex xs2 align-center :key="index_mat">{{
                mayusculas(materia.nombre)
              }}</v-flex>
            </template>
          </v-layout>
          <template v-for="(alumno, index) in alumnos">
            <alumno :alumno="alumno" :key="index" />
          </template>
        </template>
      </v-card>
    </v-dialog>
    <v-row align-center justify="center">
      <v-col md="auto">
        <v-select
          v-model="cursoSeleccionado"
          ref="cursoList"
          :items="cursos"
          item-text="descripcion"
          item-value="id"
          label="Cursos"
          @change="obtenerNotasCursos()"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import alumno from "./reporteAlumno";

export default {
  data() {
    return {
      dialog: false,
      cursoSeleccionado: "",
      materias: [],
      cursos: [],
      //curso: 1,
      alumnos: [],
    };
  },
  props: ["father"],
  components: {
    alumno,
  },
  mounted: function () {
    let resultado = API.enviar("get", "obtenerCursos", "");

    resultado
      .then((result) => {
        //console.log(result);
        if (result.data.msj == "ok") this.cursos = result.data.result;
        //this.materiasCant = result.data.length;
      })
      .catch(() => {
        //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
      });
  },
  methods: {
    mayusculas: function (string) {
      let string_aux = API.ucFirst(string);
      return string_aux;
    },
    obtenerNotasCursos: function () {
      /*console.log(
        //this.cursoSeleccionado,
        //el,
        //this.cursoSeleccionado.descripcion,
        this.$refs.cursoList.value
        //this.$refs.cursoList.value.id,
        //this.$refs.cursoList.value.descripcion
        //this.$refs.cursoList.itemValue
      );*/
      this.$emit("reporteGralGrilla:mostrarOcultarPreload");

      //let params = "curso=" + this.curso;
      let params = "idAgrupamiento=" + this.cursoSeleccionado;
      let resultado = API.enviar("get", "obtenerNotasTrimestres", params);

      resultado
        .then((result) => {
          //console.log(result);
          if (result.data.msj == "ok") {
            this.alumnos = result.data.result;
            this.materias = result.data.result[0].materias;
            //console.log(result.data.result[0].materias);
          }

          this.$emit("reporteGralGrilla:mostrarOcultarPreload");
          this.dialog = true;
        })
        .catch(() => {
          //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
        });
    },
    descargarPDF: function () {
      let local = window.localStorage.getItem("EPA_AUTH");

      if (local != null) {
        let localJson = JSON.parse(local);
        var token = localJson.token;
      }

      window.open(
        process.env.VUE_APP_API +
          API.PATH +
          "?funcion=descargarReportePDF&idAgrupamiento=" +
          this.cursoSeleccionado +
          "&token=" +
          token
      );
      /*console.log(
        API.PORT +
          API.PATH +
          "?funcion=obtenerNotasTrimestres&curso=1&idAgrupamiento=" +
          this.cursoSeleccionado
      );*/
    },
  },
};
</script>

<style>
.content {
  width: 100%;
}
h2 {
  padding-bottom: 20px;
}
.reporte {
  margin: 10px;
  width: 100%;
  font-size: 14px;
}
.card__title {
  padding-top: 0;
  padding-bottom: 0;
}
.iconoDescargar {
  cursor: pointer;
}
.colorHeaders {
  color: #fff;
  font-weight: bold;
  background-color: #4caf50;
  opacity: 0.7;
  margin: 2px;
}
</style>

